/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * Schema for the creation status of a DIDComm message. It contains the blob ID, status, attachments, and optional error message.
 */
export interface DidCommMessageBlobStatus {
    attachments: Truvity.DidCommMessageBlobAttachmentStatus[];
    /** The ID that returned on Upload operation in blob_id field. */
    blobId: string;
    errorMessage?: string;
    /**
     * The primary and unique identifier of the resource (inside tenant)
     * according to [RFC 4122](https://www.rfc-editor.org/info/rfc4122).
     */
    id: string;
    status: string;
}
